import { render, staticRenderFns } from "./scorder.vue?vue&type=template&id=5fcdd542"
import script from "./scorder.vue?vue&type=script&lang=js"
export * from "./scorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports